<template>
  <div>
    <el-card shadow="never"
             class="aui-card--fill">
      <el-form :model="dataForm"
               ref="dataForm">
        <div class="location-layout">
          <el-row :gutter="0" class="mb-20">
            <!-- 课程编号 -->
            <el-col :span="6">
              <el-form-item>
                <div class="link-type"
                     @click="courClick">{{ $t('res.courseclassroomrela.courseNo')}}</div>
                  <el-input v-model="dataForm.courseNo"
                      :disabled="true"
                      :placeholder="$t('res.courseclassroomrela.selectFromLeft')">
                </el-input>
              </el-form-item>
            </el-col>
            <!-- 课程状态 -->
            <el-col :span="6">
              <el-form-item :label="$t('res.courseclassroomrela.coursesSatus')"
                            prop="status">
                  <el-input v-model="dataForm.status"
                      :disabled="true"
                      :placeholder="$t('res.courseclassroomrela.coursesSatus')">
                </el-input>
              </el-form-item>
            </el-col>
            <!-- 课程名称 -->
            <el-col :span="6">
              <el-form-item :label="$t('res.courseclassroomrela.courseName')"
                            prop="coursecName">
                  <el-input v-model="dataForm.coursecName"
                      :disabled="true"
                      :placeholder="$t('res.courseclassroomrela.courseName')">
                </el-input>
              </el-form-item>
            </el-col>
            <!-- 课程时间 -->
            <el-col :span="6">
              <el-form-item :label="$t('res.courseclassroomrela.courseTime')"
                            prop="courseTime">
                  <el-input v-model="dataForm.courseTime"
                      :disabled="true"
                      :placeholder="$t('res.courseclassroomrela.courseTime')">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="0" class="mb-20">
            <!-- 最大人数 -->
            <el-col :span="6">
              <el-form-item :label="$t('res.courseclassroomrela.maxPersonNo')"
                            prop="maxPersonNo">
                  <el-input v-model="dataForm.maxPersonNo"
                      :disabled="true"
                      :placeholder="$t('res.courseclassroomrela.maxPersonNo')">
                </el-input>
              </el-form-item>
            </el-col>
            <!-- 最小人数 -->
            <el-col :span="6">
              <el-form-item :label="$t('res.courseclassroomrela.miniPersonNo')"
                            prop="miniPersonNo">
                  <el-input v-model="dataForm.miniPersonNo"
                      :disabled="true"
                      :placeholder="$t('res.courseclassroomrela.miniPersonNo')">
                </el-input>
              </el-form-item>
            </el-col>
            <!-- 课程分类 -->
            <el-col :span="6">
              <el-form-item :label="$t('res.courseclassroomrela.courseClassId')"
                            prop="courseClass">
                  <el-input v-model="dataForm.courseClass"
                      :disabled="true"
                      :placeholder="$t('res.courseclassroomrela.courseClassId')">
                </el-input>
              </el-form-item>
            </el-col>
            <!-- 团队分类 -->
            <el-col :span="6">
              <el-form-item :label="$t('res.courseclassroomrela.courseTeamClassification')"
                            prop="teamClass">
                  <el-input v-model="dataForm.teamClass"
                      :disabled="true"
                      :placeholder="$t('res.courseclassroomrela.courseTeamClassification')">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="0">
            <!-- 上课所需培训师数量 -->
            <el-col :span="6">
              <el-form-item :label="$t('res.coursetrainerrela.trainerCount')"
                            prop="trainerCount">
                  <el-input v-model="dataForm.trainerCount"
                      :disabled="true"
                      :placeholder="$t('res.courseclassroomrela.bySystem')">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div style="overflow-x: hidden">
        <div style="line-height: 20px; margin-top:20px">{{ $t('res.coursetrainerrela.trainerpoolExplain1') }}</div>
        <div style="line-height: 20px; margin-left:43px">{{ $t('res.coursetrainerrela.trainerpoolExplain2') }}</div>
        <div style="line-height: 20px; margin-bottom:20px; margin-left:43px ">{{ $t('res.coursetrainerrela.trainerpoolExplain3') }}</div>
        <template v-for="(item, index) in trainerpoolList">
          <el-row :key="'pool' + index"
                  style="margin-bottom: 10px;">
            <el-col :span="24"
                    style=" text-align:left;">
              <!-- 培训师池培训师选择 -->
              <span class="link-type"
                   @click="handleNodeClick(trainerpoolList[index].trainerList,index)">{{ $t('res.coursetrainerrela.trainerpool')}}{{index + 1}}</span>
              <!-- 培训师池类型选择 -->
              <div class="trainer-pool-type-select">
                <el-select v-model="trainerpoolList[index].poolType">
                    <el-option v-for="item in trainerPoolTypeList"
                              :key="item.value"
                              :label="item.name"
                              :value="item.value"></el-option>
                  </el-select>
              </div>
            </el-col>
          </el-row>
          <el-row :key="'remark' + index"
                  style="margin-bottom: 10px; line-height: 34px;">
            <el-col :span="1" style="min-width: 83px;">
              <div style="line-height: 34px">{{ $t('res.courseclassroomrela.remark') }}</div>
            </el-col>
            <el-col :span="20">
              <el-input style="display: inline-block;"
                        v-model="trainerpoolList[index].remarks"
                        :placeholder="$t('cert.inputTips')"
                        :maxlength="200">
              </el-input>
            </el-col>
            <el-col :span="2">
              <div class="show-or-hide-icon"
                  v-bind:class="{ 'el-icon-arrow-up': trainerpoolList[index].poolview,
                                          'el-icon-arrow-down': !trainerpoolList[index].poolview }"
                  @click="trainerpoolList[index].poolview = !trainerpoolList[index].poolview">&nbsp;{{ trainerpoolList[index].poolview ? $t('common.hide') : $t('res.courseclassroomrela.open') }}
              </div>
              
            </el-col>
          </el-row>
          <el-row :key="index">
            <el-col :span="24">
              <el-table :data="trainerpoolList[index].trainerList"
                        class="course-trainer-pool-table"
                        border v-show="trainerpoolList[index].poolview"
                        style="width: 100%;">
                <!-- NO -->
                <el-table-column prop="courseNo"
                                  header-align="center"
                                  type="index"
                                  align="center"
                                  :label="$t('res.courseclassroomrela.label')">
                </el-table-column>
                <!-- 培训师ID -->
                <el-table-column prop="trainerId"
                                  header-align="center"
                                  align="center"
                                  v-if="false"
                                  width="100"
                                  :label="$t('handle')">
                </el-table-column>
                <!-- 培训师编号 -->
                <el-table-column prop="trainerNo"
                                  header-align="center"
                                  align="center"
                                  v-if="false"
                                  width="100"
                                  :label="$t('handle')">
                </el-table-column>
                <!-- 培训师用户名 -->
                <el-table-column prop="userName"
                                  header-align="center"
                                  align="center"
                                  width="110"
                                  show-overflow-tooltip
                                  :label="$t('res.coursetrainerrela.trainerUserName')">
                </el-table-column>
                <!-- 员工号 -->
                <el-table-column prop="userCardNo"
                                  header-align="center"
                                  align="center"
                                  width="110"
                                  show-overflow-tooltip
                                  :label="$t('res.coursetrainerrela.userCardNo')">
                </el-table-column>
                <!-- 培训师名称 -->
                <el-table-column prop="trainerCnName"
                                  header-align="center"
                                  align="center"
                                  width="95"
                                  show-overflow-tooltip
                                  :label="$t('res.coursetrainerrela.trainerEnName')">
                </el-table-column>
                <!-- 培训师团队分类 -->
                <el-table-column prop="trainerfication"
                                  header-align="center"
                                  align="center"
                                  width="170"
                                  show-overflow-tooltip
                                  :label="$t('res.coursetrainerrela.trainerfication')">
                </el-table-column>
                <!-- 所属公司 -->
                <el-table-column prop="company"
                                  header-align="center"
                                  align="center"
                                  show-overflow-tooltip
                                  :label="$t('res.coursetrainerrela.company')">
                </el-table-column>
                <!-- 所在城市 -->
                <el-table-column prop="city"
                                  header-align="center"
                                  align="center"
                                  show-overflow-tooltip
                                  :label="$t('res.coursetrainerrela.city')">
                </el-table-column>
                <!-- 培训师状态 -->
                <el-table-column prop="trainerStatus"
                                  :formatter="statusFormatter"
                                  header-align="center"
                                  align="center"
                                  width="100"
                                  show-overflow-tooltip
                                  :label="$t('res.coursetrainerrela.trainerStatus')">
                </el-table-column>
                <!-- 培训师标签 -->
                <el-table-column prop="trainerLabel"
                                  header-align="center"
                                  align="center"
                                  width="100"
                                  :label="$t('res.coursetrainerrela.trainerLabel')">
                  <template slot-scope="scope">
                    <span class="el-dropdown-link"
                          v-if="scope.row.numberLaber !== null"
                          @click="checkLable(scope.row)">{{ $t('view') }}</span>
                  </template>
                </el-table-column>
                <!-- 年度授课目标 -->
                <el-table-column prop="yearTarget"
                                  header-align="center"
                                  align="center"
                                  :width="160"
                                  :label="$t('res.coursetrainerrela.yearTeachGoals')"
                                  :render-header="renderHeader">
                  <template slot-scope="scope">
                    <div class="course-target-limit-module">
                      <el-popover placement="bottom-start" v-if="scope.row.isEdit" ref="yearTargetNumberpop" @show="hideOther2">
                        <div slot="reference" class="trainerrela-number-chose">
                          {{ scope.row.yearTarget !== '0' ? scope.row.yearTarget : $t('couse.dealerwx') }}
                          <span class="el-icon-arrow-down chose-arrow"></span>
                        </div>
                        <div class="coursetrainerrela-target-contain">
                          <ul class="coursetrainerrela-target-list">
                            <li :class="['target-li', {'active': scope.row.yearTargetIndex==1 }]" @click="choseLimit(scope.row,1, scope.$index, index)">
                              {{ $t('couse.limit') }}
                              <span class="el-icon-arrow-right li-arrow"></span>
                            </li>
                            <li :class="['target-li', {'active': scope.row.yearTargetIndex==2 }]" @click="choseLimit(scope.row,2, scope.$index, index)">
                            {{ $t('couse.dealerwx') }}</li>
                          </ul>
                          <div class="coursetrainerrela-target-list list2" v-if="scope.row.yearTargetIndex==1">
                            <el-input-number v-model="scope.row.yearTarget" :min="1" :step="1" :precision="0" :max="999999" @change="changeNum(scope.row, scope.$index, index)"></el-input-number>
                          </div>
                        </div>
                      </el-popover>
                      <div v-else>{{ scope.row.yearTarget ==='0' ? $t('couse.dealerwx') : scope.row.yearTarget }}</div>
                    </div>
                  </template>
                </el-table-column>
                <!-- 合格 -->
                <el-table-column prop="qualfication"
                                  header-align="center"
                                  align="center"
                                  :width="140"
                                  :label="$t('res.coursetrainerrela.qualfication')">
                  <template slot-scope="scope">
                    <div style="line-height: 34px;">
                      <el-select class="qualfication-select" v-if="scope.row.isEdit" ref="qualicationSelect" @focus="hideOther" @change="changeQualfication(scope.row, scope.$index, index)"
                                  v-model="scope.row.qualfication">
                        <el-option v-for="(item,index) in qualficationArr"
                                    :key="'qualfication'+index"
                                    :label="item.name"
                                    :value="item.code">
                        </el-option>
                      </el-select>
                      <span v-else>{{ changeName(scope.row.qualfication) }}</span>
                    </div>
                  </template>
                </el-table-column>
                 <!-- 合格日期 -->
                <el-table-column prop="qualficationDate"
                                  header-align="center"
                                  align="center"
                                  width="170"
                                  :label="$t('course.validDate')">
                  <template slot-scope="scope">
                    <span v-if="scope.row.qualfication=='10'">-</span>
                    <span v-else>
                      <el-date-picker
                          ref="datepickers"
                          :disabled="!scope.row.isEdit"
                          popper-class="courseclassroomrela-datepicker"
                          v-model="scope.row.qualficationDate"
                          type="date"
                          format="yyyy-MM-dd"
                          value-format="yyyy-MM-dd"
                          :picker-options="pickerOptions"
                          :editable="false"
                          :clearable="false"
                          :placeholder="$t('user.checkdate')">
                        </el-date-picker>
                    </span>
                  </template>
                </el-table-column>
                <!-- 优先级 -->
               <el-table-column prop="priority"
                                  header-align="center"
                                  align="center"
                                  :width="130"
                                  :label="$t('res.courseclassroomrela.priority')">
                  <template slot-scope="scope">
                    <div style="line-height: 34px;">
                      <el-select class="table-priority-select"
                                  v-if="scope.row.isEdit"
                                  v-model="scope.row.priority">
                        <el-option v-for="(item,index) in priorityArr"
                                    :key="'priorityArr'+index"
                                    :label="item.name"
                                    :value="item.code">
                        </el-option>
                      </el-select>
                      <span v-else>{{ scope.row.priority }}</span>
                    </div>
                  </template>
                </el-table-column>
                <!-- 操作 -->
                <el-table-column fixed="right"
                                  align="center"
                                  :width="100"
                                  :label="$t('handle')">
                  <template slot-scope="scope">
                    <span class="table-operate-span" v-if="!scope.row.isEdit" @click="showEditInput(index, scope.$index)">{{ $t('update') }}</span>
                    <span class="table-operate-span" v-if="scope.row.isEdit" @click="saveEdit(index, scope.$index)">{{ $t('save') }}</span>
                    <span class="table-operate-line" ></span>
                    <span class="table-operate-span" v-if="!scope.row.isEdit" @click="deletetrainer(index, scope.$index)">{{ $t('delete') }}</span>
                    <span class="table-operate-span" v-if="scope.row.isEdit" @click="gotDetail(index, scope.$index)">{{ $t('user.back') }}</span>
                  </template>
                </el-table-column>
              </el-table>
              <el-row style="border-bottom: 1px solid #b4bccc; margin-bottom: 20px;"></el-row>
              <el-row class="btn-position-up"
                      style="text-align:right; margin-bottom: 10px;">
                <el-button type="danger" class="trainer-pool-button" 
                            v-show="index !== 0"
                            @click="deletePool(index)">{{ $t('res.courseclassroomrela.remove') }}</el-button>
              </el-row>
            </el-col>
          </el-row>
        </template>
        <!-- 新增按钮 -->
        <el-row class="btn-position-up">
          <el-button type="primary"
                     @click="insertPool()">{{ $t('add') }}</el-button>
        </el-row>
      </div>
      <!-- 按钮区域 -->
      <div class="btn-position-up"
           style="text-align:right;">
        <!-- 保存按钮 -->
        <el-button type="primary"
                   @click="dataFormSubmitHandle()">{{ $t('res.courseclassroomrela.save') }}</el-button>
        <!-- 关闭按钮 -->
        <ZElButton @click="backPage()">{{ $t('res.courseclassroomrela.close') }}</ZElButton>
      </div>
    </el-card>
    <!-- 课程选择页面 -->
    <el-dialog :title="$t('res.courseclassroomrela.alternativeCourse')"
               :visible="isShowcour"
               width="95%"
               :before-close="courClose">
      <cour-element v-on:couronOk="couronOk" v-bind:url="courseSelectUrl" v-bind:teamPerms="teamPerms" ref="courseSelectRef"></cour-element>
    </el-dialog>
    <!-- 培训师选择页面 -->
    <el-dialog :title="$t('res.coursetrainerrela.alternativeTrainer')"
               :visible="isShowtrainer"
               width="95%"
               :before-close="handleClose">
      <trainer-choice ref="trainerInfoRef"
                    v-on:onOk="onOk"
                    v-bind:trainerInfoList="trainerInfoList"></trainer-choice>
    </el-dialog>
    <!-- 标签查看 -->
    <el-dialog title="标签查看"
                :visible="isShowLable"
                width="70%"
                :before-close="showLableClose">
      <el-form label-position="top"
                label-width="150px"
                :ref="dataForm">
        <div>
          <el-row>
            <el-col :span="24">
              <el-form-item prop="tagName"
                            style="width: 100%!important;">
                <tag :checkedList="showcheckList"
                      :moduleId="moduleId"
                      :overLabelShow = "false"
                      :closeShow = "false"
                      :bussinessTypeId = "bussinessTypeId"
                      :brandCode="bussinessTypeChecked"
                      @getBussinessType="getBussinessType"
                      @changeCheckedList="changeShowCheckedList"
                      ref='tagTree'
                      @fatherMethod="fatherMethod"></tag>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import TrainerItem from '@/components/rm/trainer-choice/index'
import courseChoiceRela from '@/components/rm/course-rela-single/index'
import ZElButton from '@/components/rm/button/index'
import Tag from '@/components/rm/label-select/index'
import VueI18n from '@/i18n'
import Vue from 'vue'
export default {
  components: {
    Tag,
    // 'cour-element': CourItem,
    'cour-element': courseChoiceRela,
    'trainer-choice': TrainerItem,
    ZElButton
  },
  data () {
    return {
      visible: false,
      isShowcour: false,
      isShowtrainer: false,
      trainerpoolList: [{ 'remarks': '', 'poolview': true, 'trainerList': [], poolType: 'trainer' }],
      trainerInfoList: [],
      trainerInfoList1: [],
      trainerInfo: {},
      dataListLoading: false,
      priorityArr: this.enums['priority'], // 优先级
      qualficationArr: this.enums['qualfication'], // 合格
      // 选择培训师池弹出培训师选择框，确认时赋值
      courseTrainerindex: '',
      courseSelectUrl: '/rm/coursetrainerrela/coursequery',
      dataForm: {
        courseId: '',
        courseNo: '',
        status: '',
        coursecName: '',
        courseTime: '',
        maxPersonNo: '',
        miniPersonNo: '',
        courseClass: '',
        teamClass: '',
        trainerCount: '1'
      },
      isShowLable: false,
      checkList: [],
      showcheckList: [],
      // 模块id，20 代表组织管理模块
      moduleId: '20',
      bussinessTypeId: 7,
      bussinessTypeChecked: 7,
      teamPerms: 'TRAINERTEAM',
      isSave: false,
      originObj: {},
      trainerPoolTypeList: [
        { name: this.$t('res.coursetrainerrela.trainerMain'), value: 'trainer' },
        { name: this.$t('res.coursetrainerrela.trainerSecondary'), value: 'trainerAuxiliary' },
        { name: this.$t('res.coursetrainerrela.trainerAssistant'), value: 'assistant' },
        { name: this.$t('res.coursetrainerrela.trainerParticipant'), value: 'participant' }
      ],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
        }
      }
    }
  },
  activated () {
    this.$eventHub.$on('trainerAdd', (data) => {
      if (this.$refs['dataForm'] !== undefined) {
        this.$refs['dataForm'].resetFields()
        this.dataForm.courseNo = ''
      }
      this.trainerpoolList = [{ 'remarks': '', 'poolview': true, 'trainerList': [] }]
      this.$request.get(`/rm/coursetrainerrela/queryBussinessTypeIdRela`).then((res, total, code, data) => {
        if (data.data != null && data.data != undefined) {
          this.bussinessTypeId = data.data
          this.bussinessTypeChecked = data.data
        }
      })
    })
  },
  methods: {
    // table 表头修改
    renderHeader (h, {column}) {
      return h('div', [
        h('span', column.label),
          h(
            'el-tooltip',
            {
                props: {
                  effect: 'light',
                  content: this.$t('res.coursetrainerrela.yearTeachGoalsInfo'),
                  placement: 'top',
                },
            },
            [
              h('i', {
                  class: 'el-icon-question',
                  style: 'color:#409eff;margin-left:5px;',
              }),
            ],
          ),
      ]);
    },
    insertPool () {
      this.trainerpoolList.push({ 'remarks': '', 'poolview': true, 'trainerList': [], poolType: 'trainer' })
      this.dataForm.trainerCount = this.trainerpoolList.length
    },
    deletePool (index) {
      this.$confirm(this.$t('prompt.info', { 'handle': this.$t('delete') }), this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        this.trainerpoolList.splice(index, 1)
        this.dataForm.trainerCount = this.trainerpoolList.length
      })
    },
    showEditInput (bindex, index) {
      if (!this.isSave) {
        this.originObj = JSON.parse(JSON.stringify(this.trainerpoolList[bindex].trainerList[index]))
        const obj = Object.assign(this.trainerpoolList[bindex].trainerList[index], { isEdit: true })
        this.$set(this.trainerpoolList[bindex].trainerList, index, obj)
        this.isSave = true
      } else {
        this.$message({
          message: this.$t('res.courseclassroomrela.needSave'),
          type: 'warning'
        })
      }
    },
    saveEdit (bindex, index) {
      if (this.trainerpoolList[bindex].trainerList[index].qualfication === '20' && !this.trainerpoolList[bindex].trainerList[index].qualficationDate) {
        this.$message({
          message: this.$t('res.coursetrainerrela.qualficationDateNeed'),
          type: 'warning'
        })
        return false
      }
      const obj = Object.assign(this.trainerpoolList[bindex].trainerList[index], { isEdit: false  })
      this.$set(this.trainerpoolList[bindex].trainerList, index, obj)
      this.isSave = false
    },
    deletetrainer (parentIndex, childrenIndex) {
      this.trainerpoolList[parentIndex].trainerList.splice(childrenIndex, 1)
    },
    // 状态转换
    statusFormatter (row) {
      return Vue.filter('coverEnum')(row.trainerStatus, 'status')
    },
    // 培训师团队分类转换
    teamClassFormatter (row) {
      return Vue.filter('coverEnum')(row.trainerfication, 'teaTeamClass')
    },
    // 课程选择弹出页面事件
    courClick () {
      this.isShowcour = true
      this.$nextTick(() => {
        this.$refs.courseSelectRef.init()
      })
    },
    changeQualfication (val, index, k) {
      if(val.qualfication==='20'){
        const data = Object.assign(val, { 'qualficationDate': '' })
        this.$set(this.trainerpoolList[k].trainerList, index, data)
      }
    },
    changeName (val) {
      return this.qualficationArr.filter((item) => item.code===val)[0].name
    },
    // 课程选择关闭页面事件
    courClose () {
      this.isShowcour = false
    },
    couronOk (select) {
      let _this = this
      _this.dataForm.courseId = select.courseId
      _this.dataForm.courseNo = select.courseNo
      _this.dataForm.status = select.status
      _this.dataForm.coursecName = select.coursecName
      _this.dataForm.courseTime = select.courseTime
      _this.dataForm.maxPersonNo = select.maxPersonNo
      _this.dataForm.miniPersonNo = select.miniPersonNo
      _this.dataForm.courseClass = select.courseClass
      _this.dataForm.teamClass = select.teamName
      this.isShowcour = false
    },
    // 培训师选择弹出页面事件
    handleNodeClick (trainerInfoList, index) {
      this.trainerInfoList = trainerInfoList
      this.poolIndex = index
      this.courseTrainerindex = index
      this.isShowtrainer = true
      // 调用培训师弹框的初始化方法
      this.$nextTick(() => {
        this.$refs.trainerInfoRef && this.$refs.trainerInfoRef.initMethods()
      })
    },
    // 车辆选择关闭页面事件
    handleClose () {
      this.isShowtrainer = false
    },
    // 培训师弹出页面赋值给主页面
    onOk (selectList) {
      let _this = this
      let hasflg = false
      selectList.forEach(function (item) {
        _this.trainerInfoList.forEach(function (preItem) {
          if (item.trainerId === preItem.trainerId) {
            hasflg = true
          }
        })
        if (!hasflg) {
          _this.trainerInfo = {}
          _this.trainerInfo.trainerId = item.trainerId
          _this.trainerInfo.trainerNo = item.trainerNo
          _this.trainerInfo.userName = item.userName
          _this.trainerInfo.userCardNo = item.userCardNo
          _this.trainerInfo.trainerCnName = item.trainerName
          _this.trainerInfo.trainerfication = item.trainerfication
          // _this.trainerInfo.trainerfication = item.groupTypeId
          _this.trainerInfo.company = item.companyDistributor
          _this.trainerInfo.city = item.city
          _this.trainerInfo.trainerStatus = item.status
          _this.trainerInfo.trainerLabel = item.trainerLabel
          _this.trainerInfo.qualfication = item.qualfication
          _this.trainerInfo.qualficationDate = item.qualficationDate
          _this.trainerInfo.yearTarget = item.yearTarget
          _this.trainerInfo.priority = item.priority
          _this.trainerInfo.numberLaber = item.numberLaber
          _this.trainerInfo.isEdit = false
          _this.trainerpoolList[_this.poolIndex].trainerList.push(JSON.parse(JSON.stringify(_this.trainerInfo)))
        }
        hasflg = false
      })
      _this.dataForm.trainerCount = _this.trainerpoolList.length
      this.isShowtrainer = false
    },
    // 表单提交
    dataFormSubmitHandle () {
      let _this = this
      let ifag = false
      let selectIndex = 0
      // 控制保存按钮，防止重复点击保存
      _this.dataListLoading = true
      if (_this.dataForm.courseNo === null || _this.dataForm.courseNo === '') {
        // 控制保存按钮，防止重复点击保存
        _this.dataListLoading = false
        _this.$message.warning(_this.$t('res.courseclassroomrela.course'))
        return false
      } else {
        _this.trainerpoolList.forEach(function (item, index) {
          if (item.trainerList.length === 0) {
            ifag = true
            if (selectIndex === 0) {
              selectIndex = index + 1
            }
          }
        })
      }
      if (ifag) {
        _this.$message.warning(_this.$t('res.coursetrainerrela.trainerpoolSelect') + selectIndex + _this.$t('res.coursetrainerrela.trainerSelect'))
        // 控制保存按钮，防止重复点击保存
        _this.dataListLoading = false
        return false
      }
      // 触发校验
      _this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          let url = ''
          let param = ''
          url = '/rm/coursetrainerrela/save'
          const trainerpoolListArr = _this.trainerpoolList.map((item) => {
            item.trainerList = item.trainerList.map((i) => {
              Object.assign(i, { qualficationDate: i.qualfication === '20' ? i.qualficationDate + ' 23:59:59' : '' })
              return i
            })
            return item
          })
          let flag = false
          for (let i of _this.trainerpoolList) {
            for (let j of i.trainerList) {
              if (j.qualfication === '20' && !j.qualficationDate) {
                flag = true
                break;
              }
            }
          }
          if (flag) {
            this.$message({
              message: this.$t('res.coursetrainerrela.qualficationDateNeed'),
              type: 'warning'
            })
            return false
          }
          param = {
            courseId: _this.dataForm.courseId,
            trainerpoolList: trainerpoolListArr
          }
          _this.$request.post(
            url, param
          ).then((data) => {
            _this.$message({
              message: _this.$t('prompt.success'),
              type: 'success',
              duration: 500,
              onClose: () => {
                _this.dataListLoading = false
                _this.dataForm = ''
                _this.trainerpoolList = [{ 'remarks': '', 'trainerList': [] }]
                // _this.$router.go(-1)
                _this.tabRemove()
              }
            })
          })
        }
      })
    },
    backPage () {
      // this.$router.go(-1)
      let _this = this
      _this.$confirm(_this.$t('res.courseclassroomrela.cancelinfo'), _this.$t('prompt.title'), {
        confirmButtonText: _this.$t('confirm'),
        cancelButtonText: _this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        _this.tabRemove()
      })
    },
    gotDetail (bindex, index) {
      const obj = Object.assign(this.originObj, { isEdit: false  })
      this.$set(this.trainerpoolList[bindex].trainerList, index, obj)
      this.isSave = false
    },
    // 删除当前页面
    tabRemove () {
      let tabName = this.$store.state.contentTabsActiveName
      if (tabName === 'home') {
        return false
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home'
        return false
      }
      // 当前选中tab被删除
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({ name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].name })
      }
    },
    checkLable(row){
      this.isShowLable = true
      this.$request.get(`/rm/coursetrainerrela/queryCheckedCommLabel/${row.trainerId}/${this.bussinessTypeId}`).then((data) => {
        // 已选择的标签
        this.showcheckList = data ? data : []
        // 特殊情况，自己国际化
        const language = VueI18n.locale
        if (language === 'zh-CN') {
          this.showcheckList.forEach(o => {
            o.labelName = o.labelNameCn
          })
        } else {
          this.showcheckList.forEach(o => {
            o.labelName = o.labelNameEn
          })
        }
      })
    },
    showLableClose(){
      this.showcheckList = []
      this.isShowLable = false
    },
    getBussinessType (val) {
      this.bussinessTypeId = val
    },
    changeShowCheckedList (array) {
      this.showcheckList = array
    },
    hideOther2 () {
      this.$refs.qualicationSelect[0].blur()
    },
    hideOther () {
      this.$refs.yearTargetNumberpop[0].doClose()
    },
    choseLimit (row, val, index, k) {
      let data = Object.assign(row, { 'yearTargetIndex': val })
      if(val===2){
        data = Object.assign(row, { 'yearTarget': '0', 'yearTargetIndex': val })
      }
      this.$set(this.trainerpoolList[k].trainerList, index, data)
    },
    changeNum (val, index, k) {
      const data = Object.assign(val, { 'yearTarget': val.yearTarget+'' })
      this.$set(this.trainerpoolList[k].trainerList, index, data)
    },
    // 重新勾选业务标签
    fatherMethod () {
      // 特殊情况，自己国际化
      const language = VueI18n.locale
      if (language === 'zh-CN') {
        this.checkList.forEach(o => {
          o.labelName = o.labelNameCn
        })
      } else {
        this.checkList.forEach(o => {
          o.labelName = o.labelNameEn
        })
      }
    }
  }
}
</script>
<style scoped lang="scss">
.mb-20{
  margin-bottom: 20px;
}
.link-type,
.link-type:focus {
  color: #337ab7;
  cursor: pointer;
}
.link-type:hover {
  color: rgb(32, 160, 255);
}
.course-target-limit-module{
  display: flex;
  justify-content: center;
  position: relative;
  .trainerrela-number-chose{
    height: 34px;
    line-height: 34px;
    width: 130px;
    background: #FFF;
    border: 1px solid #DCDFE6;
    cursor: pointer;
    position: relative;
    .chose-arrow {
      font-size: 12px;
      position: absolute;
      top: calc(50% - 5px);
      right: 10px;
    }
  }
}
.coursetrainerrela-target-list{
  list-style: none;
  padding: 0;
  margin: 0;
  float: left;
  &.list2{
    width: 180px;
    height: 68px;
    padding-left: 20px;
    .li-name{
      display: inline-block;
    }
    .el-input-number {
      height: 32px !important;
      line-height: 32px !important;
      width: 150px !important;
    }
  }
  .target-li{
    width: 140px;
    position: relative;
    display: flex;
    align-items: center;
    padding: 0 30px 0 20px;
    height: 34px;
    line-height: 34px;
    cursor: pointer;
    .li-arrow{
      position: absolute;
      right: 0;
    }
    &.active,&:hover{
      background-color: #f5f7fa;
    }
  }
}
.trainer-pool-type-select {
  display: inline-block;
  width: 160px;
  margin-left: 20px;
}
.course-trainer-pool-table {
  .table-operate-line {
    display: inline-block;
    width: 1px;
    background-color: #409eff;
    height: 14px;
    line-height: 23px;
    margin: 0 8px;
    vertical-align: middle;
  }
  .table-operate-span {
    display: inline-block;
    color: #409eff;
    cursor: pointer;
    vertical-align: middle;
    &:hover {
      opacity: .8;
    }
  }
}
.trainer-pool-button {
  cursor: pointer;
  &.el-button--danger {
    &:hover,&:active {
      color: #fff;
      background-color: #f78989 !important;
      border-color: #f78989 !important;
      opacity: .8;
    }
  }
}
</style>
<style lang="scss">
.qualfication-select {
  .el-input--suffix .el-input__inner {
    padding: 0 10px 0 5px !important;
    text-align: center !important;
  }
}
</style>